// Extracted verbatim from JobManagement's function body (Task 7).
//
// Both are pure lookup functions that closed over nothing, and both are used
// from more than one extracted surface (the dashboard and jobs tabs, plus the
// job-details and customer-jobs modals in Task 8). Threading them through six
// components as props would be noise, so they move to a shared module and are
// imported directly. Movement only — the maps are unchanged.
export const getStatusColor = (status) => {
  const colors = {
    'created': 'bg-accent/20 text-accent',
    'diagnosing': 'bg-warning-tint text-warning',
    'diagnosed': 'bg-success-tint text-success',
    'estimating': 'bg-info-tint text-info',
    // indigo collapses to info per the plan's purple/indigo rule — not an
    // AI-primary-action, just a static status badge.
    'quoted': 'bg-info-tint text-info',
    // Was emerald/orange raw palette, the documented B2 exception; mapped by
    // meaning to the semantic tokens on 2026-09-30. Approved shares
    // Diagnosed's tint and In Progress shares Diagnosing's: the badge text
    // carries the difference, colour carries the meaning.
    'approved': 'bg-success-tint text-success',
    'in_progress': 'bg-warning-tint text-warning',
    'completed': 'bg-surface-sunken text-ink',
    'cancelled': 'bg-danger-tint text-danger',
    'on_hold': 'bg-warning-tint text-warning'
  };
  return colors[status] || 'bg-surface-sunken text-ink';
};

export const getPriorityColor = (priority) => {
  const colors = {
    'low': 'text-success',
    'normal': 'text-accent',
    'high': 'text-warning',
    'urgent': 'text-danger'
  };
  return colors[priority] || 'text-ink-muted';
};
